import useAllowPartner from "../../auth/accessToken/hooks/useAllowPartner";
import { useAccountId } from "../../auth/useAccountId";
import { useNoticeContext } from "../../common/components/NoticeBanner/FullContext";
import useMediaQuery from "../../common/hooks/useMediaQuery";
import usePaymentsEnabled from "../../common/hooks/usePaymentsEnabled";
import { globalMobileBreakpoint } from "../../styles/constants";

type EnvPatcherProps = {
    children: React.ReactNode;
};

export default function EnvPatcher({ children }: EnvPatcherProps) {
    const accountId = useAccountId();
    const isInspecting = useAllowPartner();
    const isTest = accountId.startsWith("T");
    const isPaymentsEnabled = usePaymentsEnabled();
    const isMobile = useMediaQuery(`(max-width: ${globalMobileBreakpoint}px)`);
    const notice = useNoticeContext();
    const isNoticeActive = notice.active;

    return (
        <div
            style={{
                display: "contents",
                ...(isMobile &&
                    (isInspecting || isTest || !isPaymentsEnabled) && {
                        // double the size of the topbar
                        "--topbar-height":
                            "var(--topbar-mobile-indicator-height)",
                    }),
                ...(isNoticeActive && {
                    "--topbar-height": "var(--topbar-mobile-indicator-height)",
                    ...(isMobile &&
                        (isInspecting || isTest || !isPaymentsEnabled) && {
                            "--topbar-height":
                                "var(--topbar-2x-mobile-indicator-height)",
                        }),
                }),
            }}
        >
            {children}
        </div>
    );
}
